import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetMentorshipProgramUsersByIdQueryVariables = Types.Exact<{
  programId: Types.Scalars['Int']['input'];
  userWhere?: Types.InputMaybe<Types.WorkspaceUsers_Bool_Exp>;
}>;


export type GetMentorshipProgramUsersByIdQuery = { __typename?: 'query_root', mentorshipProgram: Array<{ __typename?: 'mentorshipProgram', id: number, workspace?: { __typename?: 'workspaces', workspaceUsers: Array<{ __typename?: 'workspaceUsers', user: { __typename?: 'users', firstName: string, id: string, lastName: string, profilePhotoLink?: string | null, mentorEnabled?: boolean | null, menteeEnabled?: boolean | null } }> } | null }> };


export const GetMentorshipProgramUsersByIdDocument = gql`
    query getMentorshipProgramUsersById($programId: Int!, $userWhere: workspaceUsers_bool_exp) {
  mentorshipProgram(where: {id: {_eq: $programId}}) {
    id
    workspace {
      workspaceUsers(where: $userWhere) {
        user {
          firstName
          id
          lastName
          profilePhotoLink
          mentorEnabled
          menteeEnabled
        }
      }
    }
  }
}
    `;

/**
 * __useGetMentorshipProgramUsersByIdQuery__
 *
 * To run a query within a React component, call `useGetMentorshipProgramUsersByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMentorshipProgramUsersByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMentorshipProgramUsersByIdQuery({
 *   variables: {
 *      programId: // value for 'programId'
 *      userWhere: // value for 'userWhere'
 *   },
 * });
 */
export function useGetMentorshipProgramUsersByIdQuery(baseOptions: Apollo.QueryHookOptions<GetMentorshipProgramUsersByIdQuery, GetMentorshipProgramUsersByIdQueryVariables> & ({ variables: GetMentorshipProgramUsersByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetMentorshipProgramUsersByIdQuery, GetMentorshipProgramUsersByIdQueryVariables>(GetMentorshipProgramUsersByIdDocument, options);
      }
export function useGetMentorshipProgramUsersByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetMentorshipProgramUsersByIdQuery, GetMentorshipProgramUsersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetMentorshipProgramUsersByIdQuery, GetMentorshipProgramUsersByIdQueryVariables>(GetMentorshipProgramUsersByIdDocument, options);
        }
export function useGetMentorshipProgramUsersByIdSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetMentorshipProgramUsersByIdQuery, GetMentorshipProgramUsersByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetMentorshipProgramUsersByIdQuery, GetMentorshipProgramUsersByIdQueryVariables>(GetMentorshipProgramUsersByIdDocument, options);
        }
export type GetMentorshipProgramUsersByIdQueryHookResult = ReturnType<typeof useGetMentorshipProgramUsersByIdQuery>;
export type GetMentorshipProgramUsersByIdLazyQueryHookResult = ReturnType<typeof useGetMentorshipProgramUsersByIdLazyQuery>;
export type GetMentorshipProgramUsersByIdSuspenseQueryHookResult = ReturnType<typeof useGetMentorshipProgramUsersByIdSuspenseQuery>;
export type GetMentorshipProgramUsersByIdQueryResult = Apollo.QueryResult<GetMentorshipProgramUsersByIdQuery, GetMentorshipProgramUsersByIdQueryVariables>;